<div class="breadcrumbs col d-flex flex-row ms-2 ms-md-0 ps-md-0">
  @for (crumb of path; track crumb; let i = $index) {
<div class="d-flex-inline flex-row">
    @if (i < (path.length - 1)) {
<a [routerLink]="[crumb.url]" routerLinkActive="active">{{crumb.name}}</a>
}
    @if (i === (path.length - 1)) {
<p>{{crumb.name}}</p>
}
    @if (i < (path.length - 1)) {
<span class="px-1">></span>
}
  </div>
}
</div>
